import styled from "styled-components";

const StcSignupPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;

  .formsLayoutjawal {
    min-height: 100vh;
  }

  .gamezoneSignup {
    background: rgb(238 90 17);
  }

  .header_gamezone {
    margin-top: 5px !important;
    width: 100%;
    border-bottom: 2px solid #65378b;
  }

  .links-Section {
    position: relative;
    top: auto;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding: 12px 0 24px;
    box-sizing: border-box;
  }

  .links-Sectionjawwalgamezorid {
    top: auto !important;
    width: 100%;

    .play {
      background: var(--games_icon) center center no-repeat;
      height: 220px;
      max-width: 100%;
      background-size: contain !important;
      margin: 0 auto 8px;
    }

    input {
      margin-top: 0;
    }

    .gamezoneInput {
      background: white;
      color: black;
      padding: 10px 12px;
      border: none;
      outline: none;
      box-shadow: none;
      border-radius: 8px;
      font-size: 1rem;
      box-sizing: border-box;
    }

    .gamezoneInput:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .stc-form-wrap {
    width: 100%;
    max-width: 340px;
    margin: 12px auto 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    clear: both;
  }

  .stc-phone-row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 6px;
    direction: ltr;
  }

  .gamezonekeyph {
    width: 72px;
    flex: 0 0 72px;
    text-align: center;
    float: none;
    margin: 0;
    direction: ltr;
  }

  .gamezonenumph {
    flex: 1;
    min-width: 0;
    width: auto;
    text-align: left;
    float: none;
    margin: 0;
    direction: ltr;
  }

  .stc-subscribe-btn {
    width: 100%;
    min-width: 0;
    margin: 0 auto;
    display: block;
  }

  .links-Section a {
    color: white;
  }

  .links-Section button {
    margin-bottom: 0;
  }

  .links-Sectionjawwalgamezorid button {
    display: block;
    margin: 0 auto;
    min-width: 0;
  }

  .formsLayout {
    margin: 0 16px;
    padding-bottom: 24px;

    .verfiySection {
      top: auto !important;
      width: 100%;
      max-width: 340px;
      margin: 0 auto;
      position: relative;
    }

    .gamezoneLogo {
      max-width: 163px !important;
    }

    .header {
      margin-top: 24px;

      .logo {
        background: var(--navbarLogo) center center no-repeat;
        height: var(--loginLogoHeight);
        width: var(--loginLogoWidth);
        max-width: 350px;
        background-size: var(--background-size);
        margin-left: 0;
      }
    }

    .inputs {
      select {
        width: 35%;
        height: 43px;
      }
      input {
        width: 50%;
      }
    }

    .footer {
      .ncellTos {
        font-size: 13px;
        margin-top: 5px;
        display: flex;
        flex-direction: column;
      }
    }

    .zainiqFooter p {
      font-size: 12px;
    }
  }

  .row.text-center {
    width: 100%;
    max-width: 420px;
    margin: 18px auto 0;
  }

  @media (max-width: 576px) {
    .links-Sectionjawwalgamezorid .play {
      height: 180px;
    }

    .stc-form-wrap {
      max-width: 100%;
      padding: 0 4px;
      box-sizing: border-box;
    }

    .gamezonekeyph {
      width: 64px;
      flex: 0 0 64px;
      font-size: 0.95rem;
      padding-left: 6px;
      padding-right: 6px;
    }

    .formsLayout {
      margin: 0 12px;
    }
  }

  @media (min-width: 768px) {
    .links-Sectionjawwalgamezorid .play {
      height: 260px;
    }
  }
`;

export default StcSignupPageDisplay;
